import _ from 'lodash';
import { CUSTOM_ELEMENTS_SCHEMA, Component, OnInit } from '@angular/core';
import { AbstractControl, FormGroup, FormsModule, ReactiveFormsModule, UntypedFormControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MdbSelectModule } from 'mdb-angular-ui-kit/select';
import { CoreModule } from 'app/core/core.module';
import { MdbAutocompleteModule } from 'mdb-angular-ui-kit/autocomplete';
import { CommonModule } from '@angular/common';
import { GoogleMapsAutocompleteModule } from 'app/google-maps-autocomplete/google-maps-autocomplete.module';
import { NgxCurrencyDirective } from 'ngx-currency';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import { MdbFormsModule } from 'mdb-angular-ui-kit/forms';
import { ToastModule } from 'app/toast/toast.module';
import { MdbCheckboxModule } from 'mdb-angular-ui-kit/checkbox';
import { WebHookFormModalService } from '../../services/web-hook-form-modal/web-hook-form-modal.service';
import * as WebHookActions from '../../features/webhook-actions';

export function minArrayLength(minArrayLength: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const { length } = control.value;
        return length < minArrayLength ? { minArrayLength: { value: control.value } } : null;
    };
}

@Component({
  standalone:true,
  selector: 'app-web-hook-form',
  templateUrl: './web-hook-form.component.html',
  styleUrls: ['./web-hook-form.component.scss'],
  imports: [FormsModule,ReactiveFormsModule,MdbFormsModule,MdbSelectModule,MdbCheckboxModule,CoreModule,CommonModule,ToastModule,MdbAutocompleteModule,GoogleMapsAutocompleteModule, NgxCurrencyDirective],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class WebHookFormComponent implements OnInit {
    public eventTypes = [{
        id: "transaction",
        label: "Transaction"
    }];

    private takeUntilSubject: Subject<any> = new Subject();

    public form: FormGroup = new FormGroup({
        eventType: new UntypedFormControl(null, [Validators.required]),
        url: new UntypedFormControl("", [Validators.required, Validators.pattern(/^(?:(?:http(s)?):\/\/(www\.)?)[-a-z0-9+&@#\/%?=~_|!:,.;]*[-a-z0-9+&@#\/%=~_|]$/i)]),
        name:new UntypedFormControl("",[Validators.required])
    });

    public data: any = null;

    constructor(
        private store: Store,
        private webHookFormModalService: WebHookFormModalService,
    ) {
    }

    ngOnInit(): void {
        if(this.data) {
            this.form.get("eventType").setValue(this.data.event_types[0]);
            this.form.get("url").setValue(this.data.url);
            this.form.get("name").setValue(this.data?.name);
        }
    }

    submit() {
        if(this.form.invalid) {
            return this.form.markAllAsTouched();
        };

        if(this.data){
            this.store.dispatch(
                WebHookActions.editWebHok({webHookId:this.data.id, webHook:{ ...this.form.value }})
            )
        } else{
            this.store.dispatch(
                WebHookActions.addWebHook({
                    webHookToAdd:{...this.form.value}
                })
            )
        }
    }

    ngAfterViewInit(): void {
    }

    close(message = null) {
        this.webHookFormModalService.close(message);
    }

    ngOnDestroy() {
        this.takeUntilSubject.next(null);
        this.takeUntilSubject.complete();
    }
}
